var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"agora-pin-button",class:{ pined: _vm.pined, 'pin-button-could-hover': _vm.couldHover },on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }